import { useEffect, useState } from "react";
import React from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import Api from "../../Api/Api";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { settingsVideos } from "../../Config/Slider.js";
import { username } from "../../API";

const TvShowsLatest = () => {
  // const { username } = useParams();
  const [latest, setLatest] = useState([]);
  useEffect(() => {
    const getData = async () => {
      const { show } = await Api.getTvShowsLatest(username);
      setLatest(show);
    };
    getData();
  }, [username]);
  return (
    <div className="container-fluid mt-5">
      {latest.length !== 0 && (
        <>
          <h5 className="text-white fw-normal">Latest</h5>

          <Slider {...settingsVideos} style={{ width: "100%" }}>
            {latest &&
              latest.map((movie, index) => {
                return (
                  <div
                    className="d-inline-flex flex-column p-2"
                    key={index}
                    style={{ maxWidth: "262px" }}
                  >
                    <Link
                      // to={`/${username}/tvshowview/${movie._id}`}
                      to={`/tvshowview/${movie._id}`}
                      className="text-decoration-none"
                    >
                      <div>
                        <img
                          src={`${movie.thumbnail || movie.bannerimage}`}
                          alt={`${movie.title}`}
                          height="125px"
                          width="262px"
                          className="rounded"
                        />
                      </div>
                      <div>
                        <span className="text-light">{`${movie.title} `}</span>
                        <span className="text-light">
                          <small className="text-small">
                            {movie.Languages.length !== 0 &&
                              `(${movie.Languages})`}
                          </small>
                        </span>
                      </div>
                    </Link>
                  </div>
                );
              })}
          </Slider>
        </>
      )}
    </div>
  );
};
export default TvShowsLatest;
